module.exports = __webpack_public_path__ + "static/media/400157_02.7211d9d7.png";